import React, { Component } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { withFirebase } from './Firebase';

import Routes from './Routes';

const initialState = {
  ...Object.assign(window.pageData, {
    hasError: false,
    errorText: '',
    episodes: [],
    loading: true,
  }),
};

class App extends Component {
  constructor(props) {
    super(props);
    this.state = { ...initialState };
  }

  componentDidMount() {
    const { firebase } = this.props;
    firebase.episodes().on('value', (snapshot) => {
      const episodes = snapshot.val();

      episodes
        ? this.setState({ episodes: snapshot.val(), loading: false })
        : this.setState({
            hasError: true,
            errorText: 'Error Loading Episodes',
          });
    });
  }

  render() {
    const { basePath, episodes, loading } = this.state;
    return (
      <Router basename={basePath}>
        <Routes episodes={episodes} loading={loading} />
      </Router>
    );
  }
}

export default withFirebase(App);
